import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { IFormulario } from 'src/app/models/Formulario';
import { Credenciales } from 'src/app/models/Login';
import { IGenericResponse } from 'src/app/models/IGenericResponse';

import { NotificationService } from 'src/app/service/notificaciones.service';
import { LoginService } from 'src/app/service/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit{

  formulario: IFormulario[] = [
    { fields: ['cabecera'], headers: ['Inicio de Sesión'], type: ['cabecera'], options: [], parametros: [{strong: true, justify_content: 'center', color: '#dd0404', font_size: '20px', margin_bottom: "3%"}], validador: [false] },
    { fields: ['usuario'], headers: ['Usuario'], type: ['text'], options: [], parametros: [{ tipo: 'string', icon: 'pi pi-user', pos_icon: 'right', icon_color: 'red' }], validador: [false] },
    { fields: ['password'], headers: ['Contraseña'], type: ['password'], options: [], parametros: [{tipo: 'string', icon: 'pi pi-lock', pos_icon: 'right', icon_color: 'red'}], validador: [false] },
    { fields: ['recordar_password'], headers: ['¿Has olvidado tu contraseña?'], type: ['enlace'], options: [], parametros: [{strong: true, justify_content: 'start', color: '#dd0404', font_size: '13px', url: '/restaurarPassword', margin_top: '1%',margin_left: '1%',margin_bottom: '1%',margin_right: '1%'}], validador: [false] },
    { fields: ['inicio_sesion'], headers: ['Iniciar Sesión'], type: ['boton-enviar'], options: [], parametros: [{ color: '#dd0404', margin_top: "5%" }], validador: [false] },
  ];
  url_imagenes: string[] = ["assets/vodafone.png"];
  url_imagen_bottom: string[] = ["assets/Imagen1.png"];

  constructor(private notificacionesService: NotificationService, private loginService: LoginService, private router: Router) { }

  ngOnInit(): void {
    const token = this.loginService.getToken();
    if (token) this.router.navigate(['/panelAdministrador']);
    console.log('dev');
  }

  onRecibirFormulario(credenciales: Credenciales) {
    this.loginService.loggearUsuario(credenciales).subscribe((response: IGenericResponse) => {
      if(response.error == '') {
        this.notificacionesService.notificacionSuccess(response.message);
        this.loginService.saveToken(response.data.token);
        this.router.navigate(['/panelAdministrador']);      
      } 
      else this.notificacionesService.notificacionError(response.message);
    })
  }
}
